import { DefaultValue } from "recoil";
import { api } from "@/comn";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { eswiEnvs } from "@/tra/tancis/eswi/comn"; // 시스템 공통 유틸
import { TFormSchema, TGridSchema, TOption } from "@/comn/hooks";

export const BASE = {
    path: `${eswiEnvs.base}/esw/hs/vrfn`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/eswi/hs/vrfn`,
    hsAppApi: `${process.env.REACT_APP_API_PTLI}/api/v1/eswi/hs/app`,
    nodes: [
        // TODO 라벨 처리 필요
        { path: "/", label: "L_ESW" },
        { path: "/hs/aprv", label: "L_HS_CD" },
        { path: "/hs/aprv", label: "L_VRFN" },
    ],
};

export const URLS = {
    eswi0101001q: `${BASE.path}/eswi0101001q`,
    eswi0101002s: `${BASE.path}/eswi0101002s`,
    eswi0101003q: `${BASE.path}/eswi0101003q`,
    eswi0101004s: `${BASE.path}/eswi0101004s`,
};

export const APIS = {
    getHsVrfnList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    updateReceived: (hsAppUuid: any) => {
        return api.put(`${BASE.api}/rcve/${hsAppUuid}`, {});
    },
    getHsAppInfo: (hsAppUuid: any) => {
        return api.get(`${BASE.api}/${hsAppUuid}`, {});
    },
    getHsVrfnInfo: (hsAppUuid: any) => {
        return api.get(`${BASE.api}/${hsAppUuid}?mode=vrfn`, {});
    },
    updateHsVrfnInfo: (hsAppUuid: any, data: any) => {
        return api.put(`${BASE.api}/${hsAppUuid}`, {
            ...data,
        });
    },
    updateHsVrfnInfoSubmit: (hsAppUuid: any, data: any) => {
        return api.put(`${BASE.api}/sbmt/${hsAppUuid}`, {
            ...data,
        });
    },
    getHsAppAprvHistList: (hsAppUuid: any) => {
        return api.get(`${BASE.api}/aprv-hist/${hsAppUuid}`, {});
    },
    getHsVrfnRsptyList:(data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/rspty?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    getHsVrfnRsptyInfo: (hsAppUuid: any) => {
        return api.get(`${BASE.api}/rspty/${hsAppUuid}`, {});
    },
    getUsrByRoleLst: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/usr/by-role?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    createChangeRspty: (data: any) => {
        return api.post(`${BASE.api}/rspty`, {
            ...data,
        })
    },
};

export const SF_SCHEMA_SRCH_HS_APP: TFormSchema = {
    id: "form_cscl",
    schema: {
        orgCd: {
            type: "text",
            label: "L_OGA",
            edit: false,
        } /* OGA !== OGA ==!*/,
        orgNm: {
            type: "text",
            label: "L_OGA",
            edit: false,
        } /* OGA !== OGA ==!*/,
        srchOrgCd: {
            type: "code",
            label: "L_OGA",
            area: "orgCd",
        } /* OGA !== OGA ==!*/,
        srchOrgChpnNm: {
            type: "text",
            label: "L_OGA_OFCR_NM",
        } /* OGA Name !== OGA 명 ==!*/,
        srchOrgChpnId: {
            type: "text",
            label: "L_OGA_OFCR",
        } /* OGA Name !== OGA 명 ==!*/,
        srchHsAppNo: {
            type: "text",
            label: "L_APP_NO",
        } /* Application No !== 신청서 번호 ==!*/,
        srchOrgChpnTelno: {
            type: "text",
            label: "L_OGA_OFCR_TELNO",
            required: true,
        } /* OGA Officer Tel No. */,
        srchOrgChpnEml: {
            type: "text",
            label: "L_OGA_OFCR_EML",
            required: true,
        } /* OGA Officer Email */,
        srchPrcssStatCd: {
            type: "select",
            label: "L_STTS",
            area: "comnCd",
            comnCd: "ESW0030",
            excludes: ["DR", "RE"],
        } /* Status !== 상태 ==!*/,
        srchSbmtDtm: {
            type: "daterange",
            label: "L_SBMT_DT",
            start: { name: "srchSbmtStrtDtm" },
            end: { name: "srchSbmtEndDtm" },
        },
        srchAprvDtm: {
            type: "daterange",
            label: "L_APRVD_DT",

            start: { name: "srchAprvStrtDtm" },
            end: { name: "srchAprvEndDtm" },
        },
    },
};

export const SF_SCHEMA_HS_APP: TFormSchema = {
    id: "form_hsApp",
    schema: {
        orgCd: {
            type: "text",
            label: "L_OGA",
            edit: false,
        } /* OGA !== OGA ==!*/,
        orgNm: {
            type: "text",
            label: "L_OGA",
            edit: false,
        } /* OGA !== OGA ==!*/,
        orgChpnNm: {
            type: "text",
            label: "L_OGA_OFCR_NM",
            edit: false,
        } /* OGA Name !== OGA 명 ==!*/,
        orgChpnId: {
            type: "text",
            label: "L_OGA_OFCR",
            edit: false,
        } /* OGA Name !== OGA 명 ==!*/,
        hsAppNo: {
            type: "text",
            label: "L_APP_NO",
            edit: false,
        } /* Application No !== 신청서 번호 ==!*/,
        orgChpnTelno: {
            type: "text",
            label: "L_OGA_OFCR_TELNO",
            required: true,
            edit: true,
        } /* OGA Officer Tel No. */,
        orgChpnEml: {
            type: "text",
            label: "L_OGA_OFCR_EML",
            required: true,
            edit: true,
        } /* OGA Officer Email */,
        appDt: {
            type: "date",
            label: "L_APP_DT",
            edit: false,
        } /* Application Date !== 신청서 일자 ==!*/,
        aprvDt: {
            type: "date",
            label: "L_APRVD_DT",
            edit: false,
        } /* Approval Date !== 승인 일자 ==! */,
        prcssStatCd: {
            type: "select",
            label: "L_STTS",
            edit: false,
            area: "comnCd",
            comnCd: "ESW0030",
        } /* Status !== 상태 ==!*/,
    },
};

export const SF_SCHEMA_HS_VRFN: TFormSchema = {
    id: "form_hsAppVrfn",
    schema: {
        prcssStatCd: {
            type: "select",
            label: "L_STTS",
            edit: true,
            area: "comnCd",
            comnCd: "ESW0029",
            required: true,
            // @TODO [NEW OSC] Fee Payment !== 수수료 납부 ==!
            filter: (item: TOption) => {
                return ["AP", "RE", "RJ"].indexOf(item.value) > -1;
            },
        } /* Status !== 상태 ==!*/,
        rmrk: {
            type: "textarea",
            label: "T_RMRK",
            rows: 3,
        },
        prcssRsnCn: {
            type: "textarea",
            label: "L_VRFN_RSLT",
            rows: 3,
            required: true,
        },
    },
};

export const SG_SRCH_HS_CODE_LIST: TGridSchema = {
    id: "grid_srchHscodeList",
    options: { pagination: "out", edit: false, checkbox: false, radio: false, index: true, height: 500 },
    head: [
        { cells: [{ header: "L_APP_NO", binding: "hsAppNo", width: "*" }] },
        { cells: [{ header: "L_OGA", binding: "orgNm", width: "*" }] },
        { cells: [{ header: "L_OGA_OFCR_NM", binding: "orgChpnNm", width: "*" }] },
        { cells: [{ header: "L_SBMT_DT", binding: "sbmtDtm", width: "*" }] },
        { cells: [{ header: "L_APRV_DT", binding: "aprvDtm", width: "*" }] },

        { cells: [{ header: "L_STTS", binding: "prcssStatCd", width: "*" }] },
        { cells: [{ header: "L_ITM_CNT_1", binding: "hsCnt", width: "*" }] },
        { cells: [{ header: "L_RCVE_1", binding: "btnRcve", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "hsAppNo" }] /* Application No !== 신청서 번호 ==!*/,
        },
        {
            cells: [{ binding: "orgNm" }] /* OGA !== OGA ==!*/,
        },
        {
            cells: [{ binding: "orgChpnNm", align: "left" }],
        },
        {
            cells: [{ binding: "sbmtDtm", type: "date" }] /* Application Date !== 제출 일자 ==!*/,
        },
        {
            cells: [{ binding: "aprvDtm", type: "date" }] /* Approval Date !== 승인 일자 ==! */,
        },
        {
            cells: [
                { binding: "prcssStatCd", type: "select", area: "comnCd", comnCd: "ESW0030" },
            ] /* Status !== 상태 ==!*/,
        },
        {
            cells: [{ binding: "hsCnt" }] /* Number of Items !== 물품 개수 ==!*/,
        },
        {
            cells: [{ binding: "btnRcve" }],
        },
    ],
};

export const SG_APP_HS_CODE_LIST_R: TGridSchema = {
    id: "grid_rgsrHscodeListR",
    options: { pagination: "in", edit: false, checkbox: false, radio: false, index: true, height: 500 },
    head: [
        { cells: [{ header: "L_HS_CD", binding: "hsCd", width: 350 }] },
        { cells: [{ header: "L_DTL_DESC", binding: "godsDesc", width: "*" }] },
        { cells: [{ header: "L_INSC_TRGT_YN", binding: "inscTrgtYn", width: 100 }] },
        { cells: [{ header: "L_INSC_TRGT", binding: "imexTpCd", width: 150 }] },
        { cells: [{ header: "L_VLD_STRT_DT", binding: "appdStrtDt", width: 150 }] },
        { cells: [{ header: "L_VLD_END_DT", binding: "appdEndDt", width: 150 }] },
    ],
    body: [
        {
            cells: [
                { binding: "hsCd", type: "code", area: "hsCd", required: true, align: "left" },
            ] /* Hs code !== Hs 코드 ==!*/,
        },
        {
            cells: [{ binding: "godsDesc", align: "left" }] /* Detailed Description !== 설명 ==!*/,
        },
        {
            cells: [{ binding: "inscTrgtYn", type: "select", area: "comnCd", comnCd: "ESW0032", required: true }],
        },
        {
            cells: [
                {
                    binding: "imexTpCd",
                    type: "select",
                    area: "comnCd",
                    comnCd: "ESW0031",
                    select: true,
                },
            ] /* Inspection Target !== 검사대상 ==!*/,
        },
        {
            cells: [
                { binding: "appdStrtDt", type: "date", required: true },
            ] /**  Valid Start Date !== 유효_시작_일자 ==! */,
        },
        {
            cells: [
                { binding: "appdEndDt", type: "date", required: true },
            ] /**  Valid End Date !== 유효_종료_일자 ==! */,
        },
    ],
};

export const SG_HS_APRV_HIST_LIST: TGridSchema = {
    id: "grid_hsAprvHistList",
    options: { pagination: false, edit: false, checkbox: false, radio: false, index: true, height: 300 },
    head: [
        { cells: [{ header: "L_OGA", binding: "orgNm", width: "*" }] },
        { cells: [{ header: "L_OFCR_ROLE", binding: "asnmtOfcrTpCd", width: "*" }] },
        { cells: [{ header: "L_PRCSS_DT", binding: "ofcrPrcssDtm", width: "*" }] },
        { cells: [{ header: "L_PRCSS_STAT", binding: "prcssStatCd", width: "*" }] },
        { cells: [{ header: "L_VRFN_RSLT", binding: "prcssRsnCn", width: "*" }] },
        { cells: [{ header: "T_RMRK", binding: "rmrk", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "orgNm" }],
        },
        {
            cells: [{ binding: "asnmtOfcrTpCd", type: "select", area: "comnCd", comnCd: "ESW0009" }],
        },
        {
            cells: [{ binding: "ofcrPrcssDtm", type: "datetime" }],
        },
        {
            cells: [{ binding: "prcssStatCd", type: "select", area: "comnCd", comnCd: "ESW0029" }],
        },
        {
            cells: [{ binding: "prcssRsnCn", type: "textarea", align: "left" }],
        },
        {
            cells: [{ binding: "rmrk", type: "textarea", align: "left" }],
        },
    ],
};

export const SG_APP_HS_CODE_LIST: TGridSchema = {
    id: "grid_rgsrHscodeList",
    options: {
        pagination: "in",
        edit: true,
        checkbox: true,
        radio: false,
        index: true,
        height: 450,
        importExcel: true,
    },
    head: [
        { cells: [{ header: "L_HS_CD", binding: "hsCd", width: 350 }] },
        { cells: [{ header: "L_DTL_DESC", binding: "godsDesc", width: "*" }] },
        { cells: [{ header: "L_INSC_TRGT_YN", binding: "inscTrgtYn", width: 100 }] },
        { cells: [{ header: "L_INSC_TRGT", binding: "imexTpCd", width: 150 }] },
        { cells: [{ header: "L_VLD_STRT_DT", binding: "appdStrtDt", width: 150 }] },
        { cells: [{ header: "L_VLD_END_DT", binding: "appdEndDt", width: 150 }] },
    ],
    body: [
        {
            cells: [
                { binding: "hsCd", type: "code", area: "hsCd", required: true, excel: "A" },
            ] /* Hs code !== Hs 코드 ==!*/,
        },
        {
            cells: [{ binding: "godsDesc", excel: "B" }] /* Detailed Description !== 설명 ==!*/,
        },
        {
            cells: [
                {
                    binding: "inscTrgtYn",
                    type: "select",
                    area: "comnCd",
                    comnCd: "ESW0032",
                    required: true,
                    excel: "C",
                },
            ],
        },
        {
            cells: [
                {
                    binding: "imexTpCd",
                    type: "select",
                    area: "comnCd",
                    comnCd: "ESW0031",
                    select: true,
                    excel: "D",
                },
            ] /* Inspection Target !== 검사대상 ==!*/,
        },

        {
            cells: [
                { binding: "appdStrtDt", type: "date", required: true, excel: "E" },
            ] /**  Valid Start Date !== 유효_시작_일자 ==! */,
        },
        {
            cells: [
                { binding: "appdEndDt", type: "date", required: true, excel: "F" },
            ] /**  Valid End Date !== 유효_종료_일자 ==! */,
        },
    ],
};

export const SF_SCHEMA_SRCH_HS_APP_ASIN: TFormSchema = {
    id: "form_srchAsin",
    schema: {
        srchOrgCd: {
            type: "code",
            label: "L_OGA",
            area: "orgCd",
        } /* OGA !== OGA ==!*/,
        srchHsAppNo: {
            type: "text",
            label: "L_APP_NO",
        } /* Application No !== 신청서 번호 ==!*/,
        srchPrcssStatCd: {
            type: "select",
            label: "L_STTS",
            area: "comnCd",
            comnCd: "ESW0030",
            excludes: ["DR", "RE"],
        } /* Status !== 상태 ==!*/,
        srchSbmtDtm: {
            type: "daterange",
            label: "L_SBMT_DT",
            start: { name: "srchSbmtStrtDtm" },
            end: { name: "srchSbmtEndDtm" },
        },
        srchHsAsnmtOfcrTpCd: {
            type: "select",
            label: "L_OFCR_ROLE",
            all: false,
            area: "comnCd",
            comnCd: "ESW0009",
            excludes: ["AC", "MA", "DT", "LC", "CC", "EF", "ES", "EV", "FR", "VA", "IP", "CK"],
            defaultValue: "VE",
        } /* Officer Role */,
        srchAsnmtBsopTpCd: {
            type: "select",
            label: "L_ASNMT_BSOP_TP",
            area: "comnCd",
            comnCd: "ESW0008",
            excludes: ["ABO01","ABO03","ABO04"],
            select: false,
        },
        srchAsnmtOfcrId: {
            label: "L_ASNMT_OFCR",
            type: "text",
        } /*  Assigned Officer */,
    },
}; 

export const SG_SRCH_HS_CODE_LIST_R: TGridSchema = {
    id: "grid_srchHscodeList",
    options: { pagination: "out", edit: false, checkbox: false, radio: false, index: true, height: 500 },
    head: [
        { cells: [{ header: "L_APP_NO", binding: "hsAppNo", width: "*" }] },
        { cells: [{ header: "L_OGA", binding: "orgCd", width: 450 }] },
        { cells: [{ header: "L_SBMT_DT", binding: "sbmtDtm", width: "*" }] },
        { cells: [{ header: "L_STTS", binding: "prcssStatCd", width: "*" }] },
        { cells: [{ header: "L_ITM_CNT_1", binding: "hsCnt", width: 150 }] },
        { cells: [{ header: "L_OFCR_ROLE", binding: "asnmtOfcrTpCd", width: "*" }] },
        { cells: [{ header: "L_ASNMT_OFCR", binding: "asinOfcrId", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "hsAppNo" }] /* Application No !== 신청서 번호 ==!*/,
        },
        {
            cells: [{ binding: "orgCd", type: "select", area: "orgCd", align: "left" }] /* OGA !== OGA ==!*/,
        },
        {
            cells: [{ binding: "sbmtDtm", type: "date" }] /* Application Date !== 제출 일자 ==!*/,
        },
        {
            cells: [
                { binding: "prcssStatCd", type: "select", area: "comnCd", comnCd: "ESW0030" },
            ] /* Status !== 상태 ==!*/,
        },
        {
            cells: [{ binding: "hsCnt" }] /* Number of Items !== 물품 개수 ==!*/,
        },
        {
            cells: [
                {
                    binding: "asnmtOfcrTpCd",
                    align: "left",
                    area: "comnCd",
                    comnCd: "ESW0009",
                    type: "select",
                    // excludes: ["AC", "MA", "DT", "LC", "CC"],
                },
            ],
        },
        { cells: [{ binding: "asinOfcrId", align: "left" }] },
    ],
};

export const SF_SCHEMA_HS_APP_ASIN: TFormSchema = {
    id: "form_hsAppAsin",
    schema: {
        orgCd: {
            type: "select",
            label: "L_OGA",
            edit: false,
            area: "orgCd",
        } /* OGA !== OGA ==!*/,
        orgChpnNm: {
            type: "text",
            label: "L_OGA_OFCR_NM",
            edit: false,
        } /* OGA Officer Name !== OGA 담당자명 ==!*/,
        orgChpnId: {
            type: "text",
            label: "L_OGA_OFCR_NM",
            edit: false,
        } /* OGA Officer !== OGA 담당자 ==!*/,
        hsAppNo: {
            type: "text",
            label: "L_APP_NO",
            edit: false,
        } /* Application No !== 신청서 번호 ==!*/,
        orgChpnTelno: {
            type: "text",
            label: "L_OGA_OFCR_TELNO",
            edit: false,
        } /* OGA Officer Tel No. */,
        orgChpnEml: {
            type: "text",
            label: "L_OGA_OFCR_EML",
            edit: false,
        } /* OGA Officer Email */,
        prcssStatCd: {
            type: "select",
            label: "L_STTS",
            edit: false,
            area: "comnCd",
            comnCd: "ESW0030",
        } /* Status !== 상태 ==!*/,
        asnmtOfcrTpCd: {
            type: "select",
            label: "L_OFCR_ROLE",
            edit: false,
            area: "comnCd",
            comnCd: "ESW0009",
        },
        asinOfcrId: {
            label: "L_ASNMT_OFCR",
            type: "text",
            edit: false,
        } /*  Assigned Officer */,
    },
};

export const SF_HS_VRFN_ASIN_NEW: TFormSchema = {
    id: "form_hsVrfnAsinNewInfo",
    schema: {
        asinOfcrId: {
            label: "L_ASNMT_OFCR",
            type: "text",
            edit: false,
        } /*  Assigned Officer */,
        newAsinOfcrId: {
            type: "text",
            label: "L_NEW_ASIN_OFCR",
            edit: true,
            disabled: true,
            required: true,
        } /* Application No. */,
        asinMdfyRsn: {
            label: "L_RE_ASNMT_RSN",
            type: "textarea",
            rows: 5,
            maxLength: 2000,
            required: true,
        } /*  Re-assignment Reason */,
    },
};

export const SF_USR_BY_ROLE_SRCH: TFormSchema = {
    id: "form_usrByRoleSrch",
    schema: {
        srchUserName: {
            type: "text",
            label: "L_USER_NM",
            maxLength: 300,
        },
    },
};
export const SG_USR_BY_ROLE_LIST: TGridSchema = {
    id: "grid_usrByRoleList",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_USR_ID", binding: "userId", width: "*" }] },
        { cells: [{ header: "L_USER_NM", binding: "userName", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "userId", align: "left" }],
        },
        {
            cells: [{ binding: "userName", align: "left" }],
        },
    ],
};